import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import PageMeta from 'src/components/10-atoms/seo/PageMeta';
import Tab from 'src/components/10-atoms/tabs/Tab';
import TabHeader from 'src/components/10-atoms/tabs/TabHeader';
import Tabs from 'src/components/10-atoms/tabs/Tabs';
import Page from 'src/components/templates/page/Page.template';
import PageBody from 'src/components/templates/page/PageBody.template';
import PageHeader from 'src/components/templates/page/PageHeader.template';
import PageNavbar from 'src/components/templates/page/PageNavbar.template';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
import ChatWithUs from '../../components/ChatWithUs';
import { NodeType } from '../../graphql/common/types/node';
import { getEPHomeCanonical } from '../../seo/getEPHomeUrl';
import JoinHiringChat from './components/JoinHiringChat';
import SelectExamLevel from './components/SelectExamLevel';
import SubjectTab from './containers/SubjectTab';
import useData from './useData';
const Home = ({ navigation }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData();
    const chatRoomData = state.selectedExamLevel?.examLevel?.config?.EXAM_LEVEL?.chatRoom;
    const reviewPendingCount = (state.reviewPendingCountQuery.data?.rp_pendingCount ?? 0) <= 10
        ? state.reviewPendingCountQuery.data?.rp_pendingCount
        : '10+';
    const examLevelTitle = state.selectedExamLevel?.examLevel?.data.title;
    return (React.createElement(Page, null,
        React.createElement(PageMeta, { title: examLevelTitle
                ? `${examLevelTitle} COC Exam Preparation`
                : 'COC Exam Preparation', description: examLevelTitle
                ? `Practice ${examLevelTitle} COC written and oral exam questions, study notes, examiner feedback, and answer history — built for marine engineers.`
                : 'Practice COC written and oral exam questions, study notes, examiner feedback, and answer history — built for marine engineers.', canonical: getEPHomeCanonical(state.selectedExamLevel?.examLevel?.id, state.tabs.tabs[state.tabs.activeIndex]?.id), jsonLd: {
                '@context': 'https://schema.org',
                '@type': 'WebSite',
                name: 'MarineSamraj',
                url: 'https://marinesamraj.com',
                description: 'COC exam preparation platform for marine engineers',
                potentialAction: {
                    '@type': 'SearchAction',
                    target: 'https://marinesamraj.com/exam-prep/question-search?q={search_term_string}',
                    'query-input': 'required name=search_term_string',
                },
            } }),
        React.createElement(PageHeader, null,
            React.createElement(PageNavbar, { title: translate('Exam Preparation'), backType: "none", onBackPress: navigation.goBack, actions: [
                    {
                        Icon: props => (React.createElement(FeatherIcon, { ...props, name: "search", color: theme.palette.primary.dark })),
                        title: translate('Search'),
                        to: { screen: 'EP_QuestionSearch', params: {} },
                    },
                    state.isSuperAdmin && {
                        Icon: props => (React.createElement(FeatherIcon, { ...props, name: "check-circle", color: theme.palette.primary.dark, notificationCount: reviewPendingCount })),
                        title: translate('Reviews'),
                        to: { screen: 'RP_Home', params: {} },
                    },
                ] })),
        React.createElement(PageBody, null,
            React.createElement(JoinHiringChat, null),
            React.createElement(SelectExamLevel, { value: state.selectedExamLevel, onChange: actions.handleExamLevelChange }),
            state.selectedExamLevel?.examLevel && (React.createElement(Column, { flex: true },
                React.createElement(TabHeader, { tabs: state.tabs.tabs, activeIndex: state.tabs.activeIndex, onChange: actions.tabs.setActiveIndex, ph: theme.spacing.page, bbw: 1 }),
                React.createElement(Tabs, { activeTab: state.tabs.tabs[state.tabs.activeIndex]?.id },
                    React.createElement(Tab, { id: 'WRITTEN' },
                        React.createElement(SubjectTab, { type: NodeType.WRITTEN_SUBJECT, examLevel: state.selectedExamLevel.examLevel })),
                    React.createElement(Tab, { id: 'ORALS' },
                        React.createElement(SubjectTab, { type: NodeType.ORALS_SUBJECT, examLevel: state.selectedExamLevel.examLevel }))))),
            chatRoomData && React.createElement(ChatWithUs, { data: chatRoomData }))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default Home;
